import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon, XOctagonIcon, ClockIcon, MapIcon, ArrowDownIcon } from 'lucide-react';
export function ProblemSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="py-24 bg-navy-950 relative border-t border-navy-800" data-id="element-130">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-131">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} className="text-center mb-16" data-id="element-132">
          <motion.div variants={itemVariants} className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-red-500/10 text-red-500 mb-6" data-id="element-133">
            <AlertTriangleIcon className="w-8 h-8" data-id="element-134" />
          </motion.div>
          <motion.h2 variants={itemVariants} className="text-4xl md:text-5xl font-bold text-white mb-6 uppercase" data-id="element-135">
            El Rompecabezas Más <span className="text-red-500" data-id="element-136">Complejo</span>{' '}
            del Fútbol
          </motion.h2>
          <motion.p variants={itemVariants} className="text-lg text-slate-300 max-w-3xl mx-auto leading-relaxed" data-id="element-137">
            El Mundial 2026 es el rompecabezas más complejo de la historia del
            fútbol. Por primera vez, el torneo se divide en tres naciones con
            normativas migratorias distintas y distancias continentales. Los
            hoteles ya están proyectando tarifas 5 veces más altas de lo normal.
            El transporte entre sedes como Kansas City y Toronto es un cuello de
            botella logístico. Confiar en lo que dice un blog de viajes genérico
            es la receta perfecta para perderte el pitazo inicial y tirar miles
            de dólares a la basura.
          </motion.p>
        </motion.div>

        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} className="bg-navy-900 rounded-2xl p-8 md:p-12 border border-navy-800 shadow-2xl" data-id="element-138">
          <motion.h3 variants={itemVariants} className="text-2xl md:text-3xl font-bold text-white mb-8 text-center uppercase" data-id="element-139">
            ¿Por Qué Lo Que Has Intentado{' '}
            <span className="text-gold-400" data-id="element-140">No Funciona?</span>
          </motion.h3>

          <div className="space-y-6" data-id="element-141">
            <motion.div variants={itemVariants} className="flex items-start gap-4 p-4 rounded-xl bg-navy-800/50 border border-navy-700/50" data-id="element-142">
              <div className="flex-shrink-0 mt-1" data-id="element-143">
                <MapIcon className="w-6 h-6 text-slate-400" data-id="element-144" />
              </div>
              <p className="text-slate-300" data-id="element-145">
                <strong className="text-white" data-id="element-146">
                  Las guías tradicionales de viaje
                </strong>{' '}
                no entienden la psicología de un evento masivo; se enfocan en
                monumentos, no en cómo salir de un estadio con 80,000 personas.
              </p>
            </motion.div>

            <motion.div variants={itemVariants} className="flex items-start gap-4 p-4 rounded-xl bg-navy-800/50 border border-navy-700/50" data-id="element-147">
              <div className="flex-shrink-0 mt-1" data-id="element-148">
                <XOctagonIcon className="w-6 h-6 text-slate-400" data-id="element-149" />
              </div>
              <p className="text-slate-300" data-id="element-150">
                <strong className="text-white" data-id="element-151">Los grupos de Facebook</strong>{' '}
                están llenos de anécdotas, pero carecen de una estrategia
                técnica de transporte y costos reales.
              </p>
            </motion.div>

            <motion.div variants={itemVariants} className="flex items-start gap-4 p-4 rounded-xl bg-navy-800/50 border border-navy-700/50" data-id="element-152">
              <div className="flex-shrink-0 mt-1" data-id="element-153">
                <ClockIcon className="w-6 h-6 text-slate-400" data-id="element-154" />
              </div>
              <p className="text-slate-300" data-id="element-155">
                <strong className="text-white" data-id="element-156">
                  Esperar a que FIFA lance su app oficial
                </strong>{' '}
                suele ser demasiado tarde para reservar alojamiento a precios
                humanos.
              </p>
            </motion.div>
          </div>

          <motion.div variants={itemVariants} className="mt-10 text-center" data-id="element-157">
            <motion.a href="#oferta" whileHover={{
            scale: 1.03
          }} whileTap={{
            scale: 0.97
          }} className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-b from-gold-400 to-gold-600 text-navy-950 font-bold text-lg uppercase tracking-wide rounded-lg shadow-[0_0_20px_rgba(212,168,67,0.3)] border border-gold-300/50 transition-all cursor-pointer" data-id="element-158">
              <span data-id="element-159">Descarga Mi Guía Ahora</span>
              <ArrowDownIcon className="w-5 h-5" data-id="element-160" />
            </motion.a>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}